import { updatePassword as firebaseUpdatePassword } from 'firebase/auth';

import { authError } from '../../utils/errors.utils';
import { AuthState } from '../../interface/authState.interface';
import { AuthError } from '../../interface';

export const updatePassword = async (set: any, get: any, password: string) => {
    // Start loading
    set((state: AuthState) => ({ ...state, loading: true, errorCode: undefined }));
    const state = get();

    const user = state.firebaseAuth.currentUser;
    const onErrorResetPassword = (s: AuthState, error: any) => {
        if (authError.isWeakPassword(error)) {
            s.loginPasswordFailure(AuthError.WEAK_PASSWORD);
        } else {
            set((s_: AuthState) => ({
                ...s_,
                loading: false,
                reauthenticating: true,
            }));
        }
    };

    if (password === '') {
        state.loginPasswordFailure(AuthError.MISSING_PASSWORD);
        throw new Error('Error');
    } else {
        await firebaseUpdatePassword(user, password)
            .then(() => {
                // Update successful.
                state.loginSuccess(state.auth);
            })
            .catch((error) => {
                onErrorResetPassword(state, error);
                throw new Error('Error');
            });
        return true;
    }
};
